import { useEffect, useRef } from "react";

/**
 * AdsTerra Native Banner — rendered on every page (mounted in App.js)
 * Container ID from AdsTerra dashboard: 5e95a1e160883405de5b650aad398979
 */
export default function NativeBanner() {
  const ref = useRef(null);
  const loadedRef = useRef(false);

  useEffect(() => {
    if (loadedRef.current || !ref.current) return;
    loadedRef.current = true;
    const s = document.createElement("script");
    s.async = true;
    s.setAttribute("data-cfasync", "false");
    s.src = "https://pl29474963.effectivecpmnetwork.com/5e95a1e160883405de5b650aad398979/invoke.js";
    ref.current.appendChild(s);
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-4" data-testid="native-banner-wrapper" ref={ref}>
      <div id="container-5e95a1e160883405de5b650aad398979" />
    </div>
  );
}
